// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__04L6z"};